import { Component, HostBinding, ViewEncapsulation, QueryList, ContentChild } from '@angular/core';
import { EuiPageColumnsComponent } from './components/eui-page-columns/eui-page-columns.component';

@Component({
    selector: 'eui-page',
    templateUrl: './eui-page.component.html',
    styleUrls: ['./styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageComponent {
    @HostBinding('class')
    get cssClasses() {
        return [
            'eui-page',
            this.columns ? 'eui-page--with-columns' : '',
        ].join(' ').trim();
    }

    @ContentChild(EuiPageColumnsComponent, { static: true }) columns: QueryList<EuiPageColumnsComponent>;
}
